import { summon, AType } from "@silversea-ssc/functional-support"
import { FATAL, MISSING_CRUISE, NO_AVAILABILITY_FOR_OCCUPANCY, TRANSIENT } from "../error-codes"

export const ValidateQuoteErrorCode = summon((F) =>
    F.keysOf({
        invalidEmail: null,
        invalidCaptcha: null,
        [NO_AVAILABILITY_FOR_OCCUPANCY]: null,
        [MISSING_CRUISE]: null,
        [FATAL]: null,
        [TRANSIENT]: null,
    }),
)
export type ValidateQuoteErrorCode = AType<typeof ValidateQuoteErrorCode>
